import { render, staticRenderFns } from "./submitPage.vue?vue&type=template&id=ff0ab282&scoped=true&"
import script from "./submitPage.vue?vue&type=script&lang=js&"
export * from "./submitPage.vue?vue&type=script&lang=js&"
import style0 from "./submitPage.vue?vue&type=style&index=0&id=ff0ab282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0ab282",
  null
  
)

export default component.exports